"use client";

import dynamic from "next/dynamic";

// Lazy load FlowDiagram to avoid bundling @xyflow/react (~185KB) on every page
// Loads when a blog/tool page actually uses <FlowDiagram> in its MDX content
export const LazyFlowDiagram = dynamic(
  () =>
    import("@vllnt/ui").then((module_) => ({ default: module_.FlowDiagram })),
  {
    loading: () => (
      <div
        aria-label="Loading diagram..."
        className="h-96 bg-muted animate-pulse rounded-lg"
      />
    ),
    ssr: false,
  },
);
